import React, { useEffect, useRef, useState } from 'react'
import Header from "../../template/Header";
import Menu from "../../template/Menu";
import Footer from "../../template/Footer";
import Loading from "../../components/loading/Loading";
import moment from 'moment'
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { Button, Col, Row, Form } from "react-bootstrap";
import {
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
} from "../../components/ThemeConfig/btnConfig";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight,faMagnifyingGlass,faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import Textarea from '../../components/inputTxtarea/Textarea';
import Text from '../../components/inputTxt/Text';
import UploadIMG from "../../components/uploads/UploadIMG";
import { setTimeOutSync } from "../../utils/setTimeout";
import { getBidding, getBiddingByID, createBidding, updateBiddingByID } from "../../api/bidding_api";
import Calendarpicker from "../../components/calendars/Calendarpicker";
import { formatDate, formatDateYYYYMMDD, formatDateDDMMYYYY } from "../../utils/formatDate.js";
import {
    alertValidateData,
    alertOverLimit,
    alertConfirmChange,
    alertConfirmSave,
    alertSaved,
    alertCancel,
    alertNotFound
} from "../../components/alertValid/AlertValid.js"
import CalendarToday from '../../components/calendars/CalendarToday.js';

function AddEditBiddingInfo() {
    useButtonDynamicStyles(
        textSearchBtn,
        textResetBtn,
        textCreateBtn,
        colorSearchBtn,
        colorResetBtn,
        colorCreateBtn,
        iconSearchBtn,
        iconResetBtn,
        iconCreateBtn,
        hoverSearchBtn,
        hoverResetBtn,
        hoverCreateBtn,
        textSaveBtn,
        textCancleBtn,
        colorSaveBtn,
        colorCancleBtn,
        hoverSaveBtn,
        hoverCancleBtn,
        colorEditBtns,
        hoverEditBtns
    );
    
    const [isLoading, setLoading] = useState(false);
    const [editId, setEditId] = useState(null);
    const [txtEnTitle, setTxtEnTitle] = useState('');
    const [txtThTitle, setTxtThTitle] = useState('');
    const [txtEnDesc, setTxtEnDesc] = useState('');
    const [txtThDesc, setTxtThDesc] = useState('');
    const [images1, setImages1] = useState([]);
    const [imagesFromApi1, setImagesFromApi1] = useState([]);
    const [active, setActive] = useState(true);
    const [inputDateStart, setInputDateStart] = useState(null);
    const [inputDateStartFromApi,setInputDateStartFromApi] = useState(null);
    const [inputDateEnd, setInputDateEnd] = useState(null);
    const [isChange, setIsChange] = useState(false)
    const [shouldActiveDisabled, setShouldActiveDisabled] = useState(false)
    const [selectedDate, setSelectedDate] = useState('');
    const [status, setStatus] = useState('inactive');
    
    function ChangesetValueDateStart(value) {
        setInputDateStart(value);
        setIsChange(true)
    }
    function ChangesetValueDateEnd(value) {
        setInputDateEnd(value);
    }

    const [inputForm, setInputForm] = useState({
        inp2: "",
        inp3: ""
    });
    function setinput(inputname, value) {
        setInputForm((prev) => {
            return {
                ...prev,
                [inputname]: value,
            };
        });
    }

    const handleSelectedImages1 = (images) => {
        setImages1(images);
    };
    const handleSelectedRemoveImg1 = (data) => {
        setImages1(data);
    };

    const handleChangeInput50 = async (event,inpName) => {
        const inputValue = event.target.value;
        if (inputValue.length >= 50) {
            const result = await alertOverLimit();
                if (result.isConfirmed) {
                    const trimmedValue = inputValue.substring(0, 50); // Trim to 50 characters
                    //const lastSpaceIndex = trimmedValue.lastIndexOf(" ");
                    const finalValue = trimmedValue.substring(0); // Trim at last space
                    if (inpName=='enTitle') {                    
                        setTxtEnTitle(finalValue);
                    }
                    else if (inpName == 'thTitle') {
                        setTxtThTitle(finalValue);
                    }
                }
                else {
                    if (inpName == 'enTitle') {                    
                        setTxtEnTitle(inputValue);
                    }
                    else if (inpName == 'thTitle') {
                        setTxtThTitle(inputValue);
                    }
                }
        }
        else {
            if (inpName == 'enTitle') {                    
                setTxtEnTitle(inputValue);
            }
            else if (inpName == 'thTitle') {
                setTxtThTitle(inputValue);
            }
        }
    };

    const navigate = useNavigate();
    const navigateToBack = (page) => {
        navigate(page);
    };

    const alertValidate = async () => {
        const result = await alertValidateData();
            if (result.isConfirmed) {
                return;
            } else {
                return;
            }
    }

    const createBiddingData = async () => {
        
        let body = {
            type: 'info',
            name_en: txtEnTitle,
            name_th: txtThTitle,
            description_en: txtEnDesc,
            description_th: txtThDesc,
            cover_img: images1 ?? null,
            publish_date:inputDateStart? moment(inputDateStart, 'DD/MM/YYYY').format('YYYY-MM-DD'):'',
            active: active === false ? 0 : 1,
          };
          if (
            !body.name_en ||
            !body.name_th ||
            !body.description_en ||
            !body.description_th ||
            !body.cover_img.length > 0 ||
            !body.publish_date
          ) {
            await alertValidate();
          } else {
            const result = await alertConfirmSave();
              if (result.isConfirmed) {
                (async () => {
                  await setLoading(true);
                  const response = await createBidding(body);
                  setTimeOutSync(() => setLoading(false)).then(async () => {
                    if (response.data.status == "success") {
                        const res = await alertSaved();
                        if (res.isConfirmed) {
                          navigateToBack("/infoBiddingInformation");
                        }
                    }
                  }).finally(() => setLoading(false))
                })();
              }
          }
    };

    const updateBiddingData = async (id) => {

        let body = {
            type: 'info',
            _id: id,
            name_en: txtEnTitle,
            name_th: txtThTitle,
            description_en: txtEnDesc,
            description_th: txtThDesc,
            cover_img: images1 ?? null,
            publish_date:inputDateStart? moment(inputDateStart, 'DD/MM/YYYY').format('YYYY-MM-DD'):'',
            active: active === false ? 0 : 1,
          };
          if (
            !body.name_en ||
            !body.name_th ||
            !body.description_en ||
            !body.description_th ||
            !body.cover_img.length > 0 ||
            !body.publish_date
          ) {
            await alertValidate();
        } else {
            const result = await alertConfirmSave();
            if (result.isConfirmed) {
              await setLoading(true);
              const response = await updateBiddingByID(id, body);
              setTimeOutSync(() => setLoading(false)).then(async () => {
                if (response.data.status == "success") {
                    const res = await alertSaved();
                    if (res.isConfirmed) {
                      navigateToBack("/infoBiddingInformation");
                    }
                }
              }).finally(() => setLoading(false))
            }
        }
      };

    const handleActiveBtn = async (idData) => {
        if (idData) {
            updateBiddingData(idData);
        } else {
            createBiddingData();
        }
    };

    const handleClickCancel = async () => {
        const res = await alertCancel();
            if (res.isConfirmed) {
                navigateToBack("/infoBiddingInformation");
            }
            else { }
    };

    async function urlToBlob(url) {
        // Fetch the image data from the URL
        const response = await fetch(url);
    
        // Convert the fetched image data to Blob
        const blob = await response.blob();
    
        return blob;
    }

    const getDataBidding = async (id) => {
        await setLoading(true);
        const respon = await getBiddingByID(id);
        setTimeout(async () => {
          await setLoading(false);
        }, 1000);
    
        let dataPreview = respon.data.data;
    
        setEditId(dataPreview._id)
        setTxtEnTitle(dataPreview.name_en)
        setTxtThTitle(dataPreview.name_th)
        setTxtEnDesc(dataPreview.description_en)
        setTxtThDesc(dataPreview.description_th)
        setInputDateStart(new Date(dataPreview.publish_date))
        setInputDateStartFromApi(formatDateDDMMYYYY(dataPreview.publish_date))
        setActive(dataPreview.active === 1 ? true : false);

        setImagesFromApi1([{
            id: 0,
            status: false,
            src:
                dataPreview.cover_img === null ||
                dataPreview.cover_img === ""
                ? ''
                : dataPreview.cover_img,
            file: dataPreview.cover_img ? await urlToBlob(dataPreview.cover_img) : null,
            size: 1024*1024*4, //hard code ให้ผ่าน validate 
            type:'image/jpg' //hard code ให้ผ่าน validate
        }])
    };

    // useEffect(() => {
        //     if (inputDatePublish) {
        //       const today = new Date()
        //       console.log(today,inputDatePublish)
        //       setActive(isSameDate(new Date(),date)); // หากตรงกับวันนี้ ให้สถานะเป็น active
        //     }
        // }, [inputDatePublish]);
        const setDate = (inputname,date) => {            
            console.log('setDate',inputname,date)
        };
        const handleDateChange = (date) => {
            setInputDateStart(date); // อัปเดตวันที่ที่เลือก
            const today = new Date()
            console.log(today,date)
            setActive(isSameDate(new Date(),date)); // หากตรงกับวันนี้ ให้สถานะเป็น active
        };
        function isSameDate(date1, date2) {
            //console.log(date1,date2)
            return (
                date1.getFullYear() === date2.getFullYear() &&
                date1.getMonth() === date2.getMonth() &&
                date1.getDate() === date2.getDate()
            );
        }

    useEffect(() => {
        let id = new URLSearchParams(window.location.search).get("id");
            if (id) {
                getDataBidding(id);
                setEditId(id);
            }
    }, [])
    
    // useEffect(() => {

    //     const parseEff = moment(inputDateStart, 'DD/MM/YYYY').format('YYYY-MM-DD')
    //     const parseEnd = moment(inputDateEnd, 'DD/MM/YYYY').format('YYYY-MM-DD')

    //     if(!moment(moment().format('YYYY-MM-DD')).isBetween(parseEff, parseEnd, undefined, '[]')) {
    //      // current date/time is not between, disallow user to  can change active/inactive
    //          setShouldActiveDisabled(true)
    //          setActive(false)
    //     }else{
    //      //   allow
    //         //  setActive(true)
    //          setActive(!isChange ? active : true)
    //          setShouldActiveDisabled(false)
    //     }
    //  }, [inputDateEnd, inputDateStart])


  return (
    <>
        {isLoading ? <Loading /> : ""}
        <style>
                {`
                    .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
                        height: 200px;
                    }
                `}
        </style>
        <Header parentmenu={"OPEN TENDERING PROJECT"} />
        <Menu
            parentmenu={"infoTendering"}
            activemenu={"infoBiddingInformation"}
        />
        <div className="content-wrapper">
            <div className="container-fluid pdb-page">
                <div className="box-white">
                    <Row>
                        <Col xs={12}>
                            {editId ? (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-open.png" className="ic-user01 me-2" alt="" />
                                EDIT BIDDING INFORMATION
                            </font>
                            ) : (
                            <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                                <img src="assets/icons/ic-open.png" className="ic-user01 me-2" alt="" />
                                ADD BIDDING INFORMATION
                            </font>
                            )}
                        </Col>
                    </Row>
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    English
                                </font>
                            </Col>
                            <Col xs={6}>
                                <font className="font-size01 colorBlue01 fontMed text-decoration-underline">
                                    ภาษาไทย
                                </font>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={6}>
                                <Text
                                    value={txtEnTitle}
                                    onChange={(e) => handleChangeInput50(e,'enTitle')}
                                    placeholder="Title *"
                                />
                            </Col>
                            <Col xs={6}>
                                <Text
                                    value={txtThTitle}
                                    onChange={(e) => handleChangeInput50(e,'thTitle')}
                                    placeholder="ข้อเรื่อง *"
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2'>
                            <Col xs={6}>
                                <CKEditor
                                        editor={Editor}
                                        config={{
                                            fontSize: {
                                            options: [
                                                9,
                                                11,
                                                13,
                                                "default",
                                                17,
                                                19,
                                                21,
                                                24,
                                                28,
                                                32,
                                                36,
                                                38,
                                                42,
                                            ],
                                            },
                                            placeholder:'Description *',
                                        }}
                                        data={txtEnDesc}
                                        onChange={(event, editor) =>
                                            setTxtEnDesc(editor.getData())
                                        }
                                    />
                            </Col>
                            <Col xs={6}>
                                <CKEditor
                                        editor={Editor}
                                        config={{
                                            fontSize: {
                                            options: [
                                                9,
                                                11,
                                                13,
                                                "default",
                                                17,
                                                19,
                                                21,
                                                24,
                                                28,
                                                32,
                                                36,
                                                38,
                                                42,
                                            ],
                                            },
                                            placeholder:'คำอธิบาย *',
                                        }}
                                        data={txtThDesc}
                                        onChange={(event, editor) =>
                                            setTxtThDesc(editor.getData())
                                        }
                                    />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row>
                            <Col xs={12}>
                                <font className="font-size01 colorBlack01 fontBold">
                                Cover Image <span className=' colorRed'>*</span>
                                </font>
                            </Col>
                        </Row>
                        <Row className='mt-4'>
                            <Col xs={6}>
                                <UploadIMG
                                    limit={1}
                                    onSelectedImages={handleSelectedImages1}
                                    images={imagesFromApi1}
                                    txtDetail={"jpg. / 1920x600 px , limit size 5MB"}
                                    removeImg={handleSelectedRemoveImg1}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>
                <div className="box-white mt-4">
                    <div className='mx-5 mt-4'>
                        <Row className='mt-4'>
                            <Col xs={6} className="d-flex align-items-center pe-0">
                                <Row className="d-flex align-items-center w-100">
                                    <Col xs={3} className='pe-0'>
                                        <label className="fontLight font-size01 colorBlack01">
                                        Publish Date <span className=' colorRed'>*</span>
                                        </label>
                                    </Col>
                                    <Col xs={9} className='pe-0'>
                                        <CalendarToday
                                            dataDate={inputDateStartFromApi || null}
                                            setDatePicker={setDate} // Pass date change handler
                                            inputname={"inp2"}
                                            ChangesetValueDate={handleDateChange}
                                            inputDate={inputDateStart}
                                            minDate={new Date()} // Ensure past dates are disabled
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row className='ms-1 mt-4'>
                            <Col xs={12} className="p-0">
                                <label className="fontLight font-size03 colorBlack01">
                                Status
                                </label>
                            </Col>
                        </Row>
                        <Form className="ml-1">
                            {["radio"].map((type) => (
                                <div key={`inline3-${type}`} className="mt-2 mb-3">
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01 checked radio-item1"
                                    inline
                                    label="Active"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-1`}
                                    checked={active}
                                    onChange={(e) => setActive(true)}
                                />
                                <Form.Check
                                    className="fontLight font-size03 colorBlack01 radio-item1"
                                    inline
                                    label="Inactive"
                                    name="group3"
                                    type={type}
                                    id={`inline3-${type}-2`}
                                    checked={!active}
                                    onChange={(e) => setActive(false)}
                                />
                                </div>
                            ))}
                        </Form>
                    </div>
                </div>
                <Row className="ms-5 mt-4">
                    <Col xs={1} className="p-0 d-flex justify-content-start me-4">
                        <button
                            className="btn-cancle01"
                            onClick={() => handleClickCancel()}
                        >
                                CANCEL
                        </button>
                    </Col>
                    <Col xs={1} className="p-0 d-flex justify-content-start">
                        <button
                            className="btn-save01"
                            onClick={(e) => {
                                handleActiveBtn(editId);
                            }}
                        >
                            SAVE
                        </button>
                    </Col>
                </Row>
            </div>
        </div>
        <Footer/>
    </>
  )
}

export default AddEditBiddingInfo;